// extracted by mini-css-extract-plugin
module.exports = {"selectUncategorizedCategoryNames":"selectUncategorizedCategoryNames__MiQXd"};